const LOCAL_STORAGE = {
    ACTIVE_TAB_INDEX: 'activeTabIndex',
};
const PERIOD_TYPES = {
    OE: 'OE',
    OUTSIDE_OE: 'OUTSIDE_OE',
};

const APP_STATUSES = {
    UC: 'UC',
    CC: 'CC',
    CL: 'CL',
    EN: 'EN',
    ER: 'ER',
    PN: 'PN',
    OP: 'OP',
    SU: 'SU',
    SG: 'SG',
    QU: 'QU',
    DQ: 'DQ',
};

const APP_TYPES = {
    SEP: 'SEP',
    QEP: 'QEP',
    OE: 'OE',
};

const APP_TYPE_HEADERS = {
    SEP: 'common.updated_app',
    QEP: 'common.initial_app',
    OE: 'common.initial_app',
};

const VALIDATION_STATUSES = {
    NOTREQUIRED: 'NOTREQUIRED',
    PENDING: 'PENDING',
    PENDING_INFO: 'PENDING_INFO',
};

const VERIFICATION_STATUSES = {
    VERIFIED: 'VERIFIED',
    PENDING: 'PENDING',
    NOT_VERIFIED: 'NOT_VERIFIED',
    ACTION_NEEDED: 'ACTION_NEEDED',
};

const DMI_DOCUMENT_UPLOAD_STATUS = {
    PENDING: 'PENDING',
    PROCESSING: 'PROCESSING',
};

const FURTHER_ACTION_LINKS = {
    START_NEW_APPLICATION: 'START_NEW_APPLICATION',
    RESUME_APPLICATION: 'RESUME_APPLICATION',
    GROUPING_SCREEN: 'GROUPING_SCREEN',
    GROUPING_SCREEN_IF_ALL_ENROLLMENTS_NOT_WITHIN_THIS_MONTH:
        'GROUPING_SCREEN_IF_ALL_ENROLLMENTS_NOT_WITHIN_THIS_MONTH',
    REPORT_CHANGE: 'REPORT_CHANGE',
    REPORT_LIFE_EVENT_SHOP: 'REPORT_LIFE_EVENT_SHOP',
    UPLOAD_DOCUMENTS: 'UPLOAD_DOCUMENTS',
    CONFIRM_EVENT: 'CONFIRM_EVENT',
    VERIFICATION: 'VERIFICATION',
    SHOPPING_CART: 'SHOPPING_CART',
    CONTINUE: 'CONTINUE',
    CONTACT_US: 'CONTACT_US',
};

const SUPER_USERS = ['L2_CSR', 'SUPERVISOR', 'ADMIN'];

const APP_STATUS_MESSAGES = {
    NOT_STARTED: 'application_status.status.not_started',
    IN_PROGRESS: 'application_status.status.in_progress',
    EDIT_IN_PROGRESS: 'application_status.status.edit_in_progress',
    COMPLETE: 'indportal.dashboard.applicationStatus.status.complete',
    ERROR_PROCESSING_APP: 'application_status.status.error',
};
const APP_STATUS_LINKS = {
    START_APP: 'application_status.action.start_application',
    CONTINUE_APP: 'application_status.action.continue_application',
    VIEW_APP: 'indportal.dashboard.applicationStatus.action.viewApplication',
    RESUME_APP: 'application_status.action.resume_application',
    CANCEL_APP: 'application_status.action.cancel_application',
    EDIT_APP: 'application_status.action.edit_application',
};

const RENEWAL_STATUSES = {
    TO_CONSIDER: 'TO_CONSIDER',
    NOT_TO_CONSIDER: 'NOT_TO_CONSIDER',
    MANUAL_ENROLLMENT: 'MANUAL_ENROLMENT', // TODO: Spelling typo was made on purpose to match the old BE legacy.
    RENEWED: 'RENEWED',
    PARTIAL_RENEWED: 'PARTIAL_RENEWED',
    APP_ERROR: 'APP_ERROR',
};

const ALERT_TYPES = {
    WARNING: 'warning',
    INFO: 'info',
    ERROR: 'error',
};

const ALERT_MESSAGES_NAMES = {
    AIAN_PRIVILEGE: 'AIAN_PRIVILEGE',
    APTC_CHANGE: 'APTC_CHANGE',
    ARPA: 'ARPA',
    DMI_FAILURE: 'DMI_FAILURE',
    EXCEPTIONAL_CIRCUMSTANCES: 'EXCEPTIONAL_CIRCUMSTANCES',
    EXTENDED_OEP: 'EXTENDED_OEP',
    LOCKED: 'LOCKED',
    LOW_FPL: 'LOW_FPL',
    MEMBER_REMOVED: 'MEMBER_REMOVED',
    NEW_MEMBER_ADDED: 'NEW_MEMBER_ADDED',
    NOT_SEEKING_QHP: 'NOT_SEEKING_QHP',
    OE_APPROACHING: 'OE_APPROACHING',
    OE_END_DATE_APPROACHING: 'OE_END_DATE_APPROACHING',
    SEP_DATE: 'SEP_DATE',
    SEP_NON_AIAN_MIXED_HOUSEHOLD: 'SEP_NON_AIAN_MIXED_HOUSEHOLD',
};

const ASSOCIATION_ALERT_TYPES_ID = {
    PARTNER: 'ga.association_alert.partner',
    BROKER: 'ga.association_alert.broker',
    NO_ASSOCIATION: 'ga.association_alert.no_association',
};

const AGENT_CARD_HEADER_TITLES = [
    'ga.agents.results.header.logo_col',
    'ga.agents.results.header.contact_info',
    'ga.agents.results.header.languages',
    'ga.agents.results.header.products',
];

const ENROLLMENT_TYPES = {
    DENTAL: 'DENTAL',
    HEALTH: 'HEALTH',
};

const ENROLLMENT_MESSAGES = {
    IN_YOUR_CART: 'plans.status.in_your_cart',
    VIEW_DETAILS: 'indportal.dashboard.plans.action.viewDetails',
    COMPLETE_APP_TO_ENROLL: 'plans.action.complete_application',
    CONTINUE_SHOPPING: 'plans.action.continue_shopping',
    PICK_PLAN: 'plans.action.pick_plan',
    PICK_DIFF_PLAN: 'plans.action.pick_diff_plan',
    IN_YOUR_CART_TOOLTIP: 'further_action.cta.view_in_your_cart_tooltip',
    PENDING_TOOLTIP: 'further_action.cta.pending_tooltip',
    PENDING: 'indportal.dashboard.plans.status.pending',
    AWAITING_VERIFICATION: 'plans.status.awaiting_verification',
    AWAITING_VERIFICATION_TOOLTIP: 'plans.status.awaiting_verification.tooltip',
    TERMINATED: 'plans.status.terminated',
    FUTURE_TERM: 'plans.status.future_terminated',
    ENROLLED: 'plans.status.enrolled',
    CONFIRM: 'plans.status.confirm',
    SAVED_PLAN: 'plans.status.saved_plan',
    SAVED_PLAN_TOOLTIP: 'plans.status.saved_plan_tooltip',
};

const ENROLLMENT_STATUSES = {
    PEND: 'PEND',
    PENDING: 'PENDING',
    ENROLLED: 'ENROLLED',
    TERMINATED: 'TERM',
    FUTURE_TERM: 'FUTURE_TERM',
    CONFIRM: 'CONFIRM',
    SAVED_PLAN: 'SAVED_PLAN',
    CANCEL: 'CANCEL',
    PEND_CANCELLED: 'PEND_CANCELED',
};

const FORMATTED_DATES = {
    serverDate: 'serverDate',
    currentYear: 'currentYear',
    previousYear: 'previousYear',
    nextYear: 'nextYear',
    oepStartDate: 'oepStartDate',
    oepEndDate: 'oepEndDate',
    oeYear: 'oeYear',
    oepEnrollEndDate: 'oepEnrollEndDate',
    commonDate: 'commonDate',
    commentMonthHour: 'commentMonthHour',
    exceptionalCircumstancesEndDate: 'exceptionalCircumstancesEndDate',
    exceptionalCircumstancesEndDateMMMMDo: 'exceptionalCircumstancesEndDateMMMMDo',
    exceptionalCircumstancesEndDateESFormat: 'exceptionalCircumstancesEndDateESFormat',
    globalConfigCoverageStartDate: 'globalConfigCoverageStartDate',
};

const ELIGIBILITY_STATUSES = {
    NOT_ELIGIBLE_ENROLL: 'household_section.eligibility.status.not_eligible_enroll',
    NOT_ELIGIBLE_CSR: 'indportal.dashboard.householdSection.eligibility.status.notEligibleCsr',
    ELIGIBLE_APTC: 'indportal.dashboard.householdSection.eligibility.status.eligibleAptc',
    ELIGIBLE_SUBSIDY: 'household_section.eligibility.status.eligible_subsidy',
    ELIGIBLE_CSR: 'householdSection.eligibility.status.eligibleCsr',
    ELIGIBLE_CSR_ANY_MEMBER: 'householdSection.eligibility.status.eligibleCsrAnyMember',
    ELIGIBLE_QHP: 'household_section.eligibility.status.eligible_QHP',
    ELIGIBLE_STATE_SUBSIDY_2: 'householdSection.eligibility.status.eligibleStateSubsidy2',
    ELIGIBLE_STATE_SUBSIDY_3: 'householdSection.eligibility.status.eligibleStateSubsidy3',
};

const ELIGIBILITY_INDICATORS = {
    CHIP: 'household_section.eligibility.indicator.CHIP',
    AI_AN: 'household_section.eligibility.indicator.AI_AN',
    ASSESSED_MEDICAID: 'household_section.eligibility.indicator.assessed_medicaid',
    MEDICAID: 'household_section.eligibility.indicator.medicaid',
    CHIP_ASSESSED: 'household_section.eligibility.indicator.CHIP_assessed',
    NOT_SEEKING_COVERAGE: 'household_section.eligibility.indicator.not_seeking_coverage',
    NOT_ELIGIBLE_QHP: 'household_section.eligibility.indicator.not_eligible_QHP',
    POTENTIALLY_EMERGENCY_MEDICAID_ELIGIBLE:
        'household_section.eligibility.indicator.potentially_emergency_medicaid_eligible',
    BHP: 'household_section.eligibility.indicator.bhp',
    ASSESSED_BHP: 'household_section.eligibility.indicator.assessedBhp',
};

const ALL_ELIGIBILITY_TYPES = {
    QHP: 'QHP',
    APTC: 'APTC',
    STATE_SUBSIDY: 'STATE_SUBSIDY',
    CSR: 'CSR',
    CSR_TURQUOISE: 'CSR_TURQUOISE',
    ASSESSED_MEDICAID: 'ASSESSED_MEDICAID',
    ASSESSED_MAGI_MEDICAID: 'ASSESSED_MAGI_MEDICAID',
    ASSESSED_CHIP: 'ASSESSED_CHIP',
    MEDICAID_REFERRAL: 'MEDICAID_REFERRAL',
    MEDICAID: 'MEDICAID',
    MEDICAID_OR_CHIP: 'MEDICAID_OR_CHIP',
    NOT_SEEKING: 'NOT_SEEKING',
    NOT_QHP: 'NOT_QHP',
    POTENTIALLY_EMERGENCY_MEDICAID_ELIGIBLE: 'POTENTIALLY_EMERGENCY_MEDICAID_ELIGIBLE',
    STATE_SUBSIDY_2: 'STATE_SUBSIDY_2',
    STATE_SUBSIDY_3: 'STATE_SUBSIDY_3',
    BHP: 'BHP',
    ASSESSED_BHP: 'ASSESSED_BHP',
};

const APP_STATUS_INDICATORS = {
    ERROR: {
        msgKey: 'common.status.error_in_processing',
        modifierClassName: 'app-status-indicator--error',
    },
    IN_PROGRESS: {
        msgKey: 'common.status.in_progress',
        modifierClassName: 'app-status-indicator--in-progress',
    },
    COMPLETED: {
        msgKey: 'common.status.completed',
        modifierClassName: 'app-status-indicator--completed',
    },
    CANCELLED: {
        msgKey: 'common.status.cancelled',
        modifierClassName: 'app-status-indicator--cancelled',
    },
    CLOSED: {
        msgKey: 'common.status.closed',
        modifierClassName: 'app-status-indicator--closed',
    },
};

const EVENT_NAMES = {
    LOW_FPL: 'LOW_FPL',
    INCOME_CHANGE_VALUES: [
        'INCOME_CHANGE',
        'CHANGE_IN_INCOME',
        'INCOME_CHANGE_CSR',
        'INCOME_CHANGE_FUTURE',
        'INCOME_CHANGE_CSR_FUTURE',
    ],
};

const ELIGIBILITY_OPTIONS = {
    CSR_ELIGIBLE: 'csrEligible',
    APTC_ELIGIBLE: 'aptcEligible',
    STATE_SUBSIDY: 'stateSubsidyEligible',
    STATE_SUBSIDY_2: 'stateSubsidy2Eligible',
    STATE_SUBSIDY_3: 'stateSubsidy3Eligible',
};

export {
    AGENT_CARD_HEADER_TITLES,
    ALERT_MESSAGES_NAMES,
    ALERT_TYPES,
    ALL_ELIGIBILITY_TYPES,
    APP_STATUSES,
    APP_STATUS_INDICATORS,
    APP_STATUS_LINKS,
    APP_STATUS_MESSAGES,
    APP_TYPES,
    APP_TYPE_HEADERS,
    ASSOCIATION_ALERT_TYPES_ID,
    DMI_DOCUMENT_UPLOAD_STATUS,
    ELIGIBILITY_INDICATORS,
    ELIGIBILITY_OPTIONS,
    ELIGIBILITY_STATUSES,
    ENROLLMENT_MESSAGES,
    ENROLLMENT_STATUSES,
    ENROLLMENT_TYPES,
    EVENT_NAMES,
    FORMATTED_DATES,
    FURTHER_ACTION_LINKS,
    LOCAL_STORAGE,
    PERIOD_TYPES,
    RENEWAL_STATUSES,
    SUPER_USERS,
    VALIDATION_STATUSES,
    VERIFICATION_STATUSES
};

